import { useCallback, useEffect } from 'react';

import { useLinkNavigate } from '@gogame/screens';
import { useSocket } from '@gogame/sockets';

import { marketingPlanningGridLink } from 'scenes/MarketingPlanning/navigation';

import { EVENT_GO_TO_GRID } from '../constants';

export const useSocketGoToGrid = () => {
  const socket = useSocket();

  const marketingPlanningGridNavigate = useLinkNavigate(
    marketingPlanningGridLink
  );

  const handleDraftPlan = useCallback(() => {
    marketingPlanningGridNavigate();
  }, [marketingPlanningGridNavigate]);

  useEffect(() => {
    socket.on(EVENT_GO_TO_GRID, handleDraftPlan);
    return () => {
      socket.off(EVENT_GO_TO_GRID, handleDraftPlan);
    };
  }, [socket, handleDraftPlan]);
};
